export default __webpack_public_path__ + "static/our-team-image-f32518c451a765fa55a86f320cfa1c5f.png";